module.exports = __webpack_public_path__ + "img/product-s618-1000.7a18cec0.png";